/**
 * Filters out common words that are typically not useful in a query.
 * @param word - The word to be filtered.
 * @returns A boolean indicating whether the word should be included in the query (true) or not (false).
 */
const filterQueryWord = (word: string): boolean => {
    const commonWords = [
        "a",
        "an",
        "the",
        "in",
        "on",
        "at",
        "for",
        "to",
        "from",
        "by",
        "with",
        "is",
        "are",
        "was",
        "were",
        "has",
        "have",
        "had",
        "be",
        "been",
        "being",
        "and",
        "or",
        "not",
        "but",
        "of",
        "about",
        "over",
        "under",
        "above",
        "below",
        "within",
        "without",
        "between",
        "among",
        "through",
        "though",
        "during",
        "before",
        "after",
        "while",
        "if",
        "else",
        "then",
        "when",
        "where",
        "how",
        "what",
        "which",
        "who",
        "whom",
        "whose",
        "why",
        "can",
        "could",
        "may",
        "might",
        "will",
        "would",
        "shall",
        "should",
        "must",
        "ought",
        "it",
        "this",
        "that",
        "these",
        "those",
        "here",
        "there",
        "now",
        "then",
    ];

    return !commonWords.includes(word.toLowerCase());
};

export default filterQueryWord;
